




















































import { Component, Vue, Inject, Prop, Watch, Mixins, Emit, Model } from 'vue-property-decorator'
import Emitter from 'view-design/src/mixins/emitter'
import OrderApi from '@/api/order/list/index'
@Component({})
export default class CategorySelect extends Mixins(Emitter) {
  @Prop({
    type: String,
    default: '',
  })
  orderId!: ''
  @Prop({
    type: Boolean,
    default: false,
  })
  isClearFilter!: boolean
  @Watch('isClearFilter')
  getIsClearFilter(value) {
    if (value) {
      console.log('清除')
      this.selectedClassifyList = []
    }
  }
  shoppingAreadyHaveClassify: any = []
  selectedClassifyList: any[] = []
  modal1: boolean = false

  handleOpenClassifyDialog() {
    OrderApi.getClassifyByOrderId(this.orderId).then((res) => {
      console.log('分类', res)
      if (res.data && res.data.length) {
        const tempArr = this.listToTree(res.data)
        tempArr.forEach((item) => {
          item.isShowMore = false
        })
        console.log(tempArr)
        this.shoppingAreadyHaveClassify = tempArr
        this.modal1 = true
      }
    })
  }
  showMore(item, index) {
    const obj = this.shoppingAreadyHaveClassify[index]
    const box = document.getElementById(`center-box${index}`)
    if (!obj.isShowMore) {
      box.style.height = 'auto'
    } else {
      box.style.height = '36px'
    }
    this.$set(this.shoppingAreadyHaveClassify[index], 'isShowMore', !this.shoppingAreadyHaveClassify[index].isShowMore)
  }
  handleSelectTwoNav(sonItem, parentItem) {
    if (this.selectedClassifyList.length) {
      if (this.selectedClassifyList.includes(sonItem.id)) {
        const temIndex = this.selectedClassifyList.findIndex((item) => item == sonItem.id)
        this.selectedClassifyList.splice(temIndex, 1)
      } else {
        let isHave = false
        for (let i = 0; i < this.selectedClassifyList.length; i++) {
          const element = this.selectedClassifyList[i]
          const tempSonIndex = parentItem.children.findIndex((item1) => item1.id == element)
          if (tempSonIndex > -1) {
            isHave = true
            this.selectedClassifyList.splice(i, 1, sonItem.id)
            break
          }
        }
        if (!isHave) {
          this.selectedClassifyList.push(sonItem.id)
        }
      }
    } else {
      this.selectedClassifyList = [sonItem.id]
    }
  }
  listToTree(list) {
    const map = {}
    let node
    const roots = []
    for (let i = 0; i < list.length; i += 1) {
      map[list[i].id] = i
      list[i].children = []
    }
    for (let i = 0; i < list.length; i += 1) {
      node = list[i]
      if (node.parentId !== null) {
        if (map[node.parentId] != null) {
          list[map[node.parentId]].children.push(node)
        }
      } else {
        roots.push(node)
      }
    }
    return roots
  }
  ok() {
    if (!this.selectedClassifyList.length) {
      this.$Notice.warning({
        desc: '请先至少选择一项分类',
      })
    } else {
      this.modal1 = false
      this.$emit('on-change', this.selectedClassifyList)
    }
  }
  cancel() {
    this.selectedClassifyList = []
    this.modal1 = false
  }
}
